import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoLeft from '../assets/wise_logo.png';
import logoRight from '../assets/DCLInnovationLogo.jpg'; // Add your second logo here

export default function LogoHeader() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between', // space between for left & right logo
        padding: '10px 20px',
        backgroundColor: '#fff',
        borderBottom: '2px solid #eee',
        flexWrap: 'wrap' // mobile responsive
      }}
    >
      {/* Left logo - clickable */}
      <div style={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
        <img
          src={logoLeft}
          alt="Left Logo"
          style={{
            height: '150px',
            maxWidth: '100%',
            objectFit: 'contain'
          }}
        />
      </div>

      {/* Right logo */}
      <div>
        <img
          src={logoRight}
          alt="Right Logo"
          style={{
            height: '150px',
            maxWidth: '100%',
            objectFit: 'contain'
          }}
        />
      </div>
    </div>
  );
}
